export const alertOutlinedWarningStyles = theme => ({
  color: theme.palette.warning.dark,
  textAlign: 'center',
});

export const alertRootStyles = theme => ({
  padding: theme.spacing(0, 1),
});

export const calendarContentStyles = theme => ({
  display: 'grid',
  gridAutoFlow: 'row',
  gridRowGap: theme.spacing(1),
});

export const contentStyles = theme => ({
  display: 'grid',
  gridAutoFlow: 'row',
  gridRowGap: theme.spacing(2),
  overflowY: 'auto',
  padding: theme.spacing(3),
});

export const contentWrapperStyles = {
  flexGrow: 1,
  height: '100%',
  width: '100%',
};

export const detailStyles = {
  display: 'grid',
  gridTemplateColumns: '3fr 1fr',
};

export const detailActiveStyles = {
  alignSelf: 'center',
  gridColumn: '2',
  gridRow: '1 / 3',
  justifySelf: 'end',
};

export const detailBadgeStyles = {
  gridColumn: '2',
  gridRow: '2',
  justifySelf: 'end',
};

export const detailDataCompanyStyles = {
  gridColumn: '2',
  gridRow: '2',
  justifySelf: 'end',
};

export const detailLabelStyles = theme => ({
  fontWeight: '400',
  gridColumn: '1',
  gridRow: '1',
  marginBottom: theme.spacing(0.5),
});

export const detailValueStyles = theme => ({
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  gridColumn: '1',
  gridRow: '2',
});

export const footerButtonStyles = theme => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  width: 135,
});
